// PKCE (RFC 7636) and random-value helpers for the OAuth round-trip.
// Pure functions over Web Crypto, so they run unchanged in the browser,
// Electron and Vitest (Node 24 has `crypto.subtle` and `btoa` globally).

export const base64Url = (bytes: Uint8Array): string =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

/** `byteLength` random bytes, base64url-encoded (no padding). */
export const randomUrlSafe = (byteLength: number): string => base64Url(crypto.getRandomValues(new Uint8Array(byteLength)));

/** S256 code challenge for a PKCE verifier. */
export const pkceChallenge = async (verifier: string): Promise<string> =>
  base64Url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
